
import { ModelMaintenanceComponent } from './model-maintenance/model-maintenance.component';
import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CasesUsedComponent } from './cases-used/cases-used.component';
import { PiecesUsedComponent } from './pieces-used/pieces-used.component';
import { InventoryAdjustmentsComponent } from './inventory-adjustments/inventory-adjustments.component';
import { HomeComponent } from './home/home.component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [    
    {
        path: 'home', component: HomeComponent, canActivate: [MsalGuard]
    },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'login', component: LoginComponent, canActivate: [MsalGuard] },
    { path: 'model-maintenance', component: ModelMaintenanceComponent, canActivate: [MsalGuard] },
    { path: 'view', component: ModelMaintenanceComponent, canActivate: [MsalGuard] },
    { path: 'copy', component: ModelMaintenanceComponent, canActivate: [MsalGuard] },
    { path: 'cases-used', component: CasesUsedComponent, canActivate: [MsalGuard] },
    { path: 'pieces-used', component: PiecesUsedComponent, canActivate: [MsalGuard] },
    { path: 'dashboard', component: DashboardComponent, canActivate: [MsalGuard] },
    { path: 'inventory-adjustments', component: InventoryAdjustmentsComponent, canActivate: [MsalGuard] },
    { path: '**', redirectTo: 'home' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
    exports: [RouterModule]
})
export class AppRoutingModule { }